// extracted by mini-css-extract-plugin
export default {"pageContainer":"public-quick-pricer_pageContainer__LfZEB","header":"public-quick-pricer_header__0bWiY","bodyContainer":"public-quick-pricer_bodyContainer__3FaF1"};